export const UC_APIS = {
  // Telegram campaigns
  telegramCampaignsList: "notifications/tg/campaigns/list",
  telegramCampaignDetails: "notifications/tg/campaign/details",
  telegramCampaignCreate: "notifications/tg/campaign/create",
  telegramCampaignUpdate: "notifications/tg/campaign/update",
  telegramCampaignDelete: "notifications/tg/campaign/delete",
  telegramCampaignPause: "notifications/tg/campaign/pause",
  telegramCampaignRecipients: "notifications/tg/campaign/recipients",

  // Telegram audience
  telegramCommunities: "notifications/tg/audience/communities",
  telegramContactSearch: "notifications/tg/audience/contacts/search",
  telegramAudienceSummary: "notifications/tg/audience/summary",

  // Unified templates across WhatsApp, Telegram, Push and Community
  broadcastTemplates: "notifications/broadcast/templates/list",

  // Telegram / Push templates
  telegramDefaultTemplates: "notifications/tg/templates/list",
  telegramCustomTemplates: "notifications/tg/templates/custom/list",
  telegramTemplateDetails: "notifications/tg/template/details",
  telegramTemplateCreate: "notifications/tg/templates/custom/create",
  telegramTemplateUpdate: "notifications/tg/templates/custom/update",
  telegramTemplateDelete: "notifications/tg/templates/custom/delete",

  pushDefaultTemplates: "notifications/push/templates/list",
  pushCustomTemplates: "notifications/push/templates/custom/list",
  pushTemplateDetails: "notifications/push/template/details",
  pushTemplateCreate: "notifications/push/templates/custom/create",
  pushTemplateUpdate: "notifications/push/templates/custom/update",
  pushTemplateDelete: "notifications/push/templates/custom/delete",

  // Community templates/campaigns
  communityDefaultTemplates: "notifications/community/templates/list",
  communityCustomTemplates: "notifications/community/templates/custom/list",
  communityTemplateDetails: "notifications/community/template/details",
  communityTemplateCreate: "notifications/community/templates/custom/create",
  communityTemplateUpdate: "notifications/community/templates/custom/update",
  communityTemplateDelete: "notifications/community/templates/custom/delete",
  communitySpaces: "notifications/community/audience/spaces",
  communityAudienceSummary: "notifications/community/audience/summary",
  communityCampaignsList: "notifications/community/campaigns/list",
  communityCampaignDetails: "notifications/community/campaign/details",
  communityCampaignCreate: "notifications/community/campaign/create",
  communityCampaignUpdate: "notifications/community/campaign/update",
  communityCampaignDelete: "notifications/community/campaign/delete",
  communityCampaignPause: "notifications/community/campaign/pause",
  communityCampaignRecipients: "notifications/community/campaign/recipients",

  // Push campaigns
  pushAvailability: "notifications/push/availability",
  pushCampaignsList: "notifications/push/campaigns/list",
  pushCampaignDetails: "notifications/push/campaign/details",
  pushCampaignCreate: "notifications/push/campaign/create",
  pushCampaignUpdate: "notifications/push/campaign/update",
  pushCampaignDelete: "notifications/push/campaign/delete",
  pushCampaignPause: "notifications/push/campaign/pause",
  pushCampaignRecipients: "notifications/push/campaign/recipients",
  pushAudienceSummary: "notifications/push/audience/summary",

  // Trade calls / rationale PDF
  tradeCallsPicker: "notifications/tg/campaigns/list",
  rationalePdfDesign: "notifications/tg/rationale-pdf/design",
  rationalePdfDesignUpdate: "notifications/tg/rationale-pdf/design/update",
  rationalePdfUploadUrl: "notifications/tg/rationale-pdf/upload-url",
  rationalePdfPreview: "notifications/tg/rationale-pdf/preview",

  // Reports
  sebiReportsVisibility: "notifications/tg/sebi/reports/visibility",
  reportUpload: "content/report/upload",

  // WhatsApp templates (existing)
  whatsappCustomTemplates: "notifications/wa/templates/custom/list",

  // Audience groups (shared with WhatsApp)
  whatsappAudienceGroups: "notifications/whatsapp/audience/paginated/list/v2",

  // Telegram connection / credits
  telegramStatus: "users/telegram/status",
  telegramCredits: "business/credits/get/feature/credits",
};

export const TELEGRAM_CREDIT_FEATURE_KEY = "telegram_broadcast";
export const PUSH_CREDIT_FEATURE_KEY = "push_broadcast";

export const REPORT_TYPE = {
  RESEARCH_REGISTER: 15,
  CLIENT_COMMUNICATION_LOG: 16,
  TELEGRAM_EXPORT: 17,
  COMMUNITY_EXPORT: 18,
  PUSH_EXPORT: 19,
};
